import "core-js/modules/es.array.iterator";
import "core-js/modules/es.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.link";
import "core-js/modules/web.dom-collections.iterator";
import React from 'react';
import { isBlank } from 'helpers/verify';
import { marked } from './marked';
/*
  Here, we override renderers for markdown tokens we do not want to support.

  See https://github.com/markedjs/marked/blob/master/docs/USING_PRO.md for the full list of
  token renderers, and their arguments.
*/

var renderer = new marked.Renderer();
/* Block Level */

renderer.code = function () {
  return '';
};

renderer.blockquote = function () {
  return '';
};

renderer.html = function () {
  return '';
};

renderer.heading = function () {
  return '';
};

renderer.hr = function () {
  return '';
};

renderer.table = function () {
  return '';
};

renderer.tablerow = function () {
  return '';
};

renderer.tablecell = function () {
  return '';
};

renderer.paragraph = function (text) {
  return /\n/m.test(text) ? "<p>".concat(text, "</p>") : text;
}; // Don't wrap single-line strings in a <p>

/* Inline Level */


renderer.codespan = function () {
  return '';
};

renderer.link = function () {
  return '';
};

renderer.image = function () {
  return '';
};

var options = {
  renderer: renderer,
  sanitize: true,
  smartypants: true
};
var cache = new Map();
export var resetMarkdownCache = function resetMarkdownCache(key) {
  return key ? cache.delete(key) : cache.clear();
};

var parseMarkdown = function parseMarkdown(md, key) {
  if (__SERVER__) {
    // We don't cache markdown renders on the server,
    // since Map is shared across requests.
    return marked(md, options);
  }

  if (key && cache.has(key)) {
    return cache.get(key);
  }

  var parsed = marked(md, options);

  if (key) {
    cache.set(key, parsed);
  }

  return parsed;
}; // This data is controlled by us, and marked sanitizes HTML. So we can "safely" use dangerouslySet here.
// eslint-disable-next-line react/no-danger


export var renderMarkdown = function renderMarkdown(md, key) {
  return typeof md === 'string' && !isBlank(md) ? React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: parseMarkdown(md, key)
    }
  }) : null;
};